import parse from 'html-react-parser';
import React from 'react';
import { MessageSimple, useMessageContext } from 'stream-chat-react';

import { Box } from '@mui/material';
import DOMPurify from 'dompurify';
import { DateTime } from 'luxon';

import { MessageEditedAt, MessageWrapper } from './styled';

const sanitizeHtml = (message: string) => {
	const rawHtml = message.trim();
	const cleanHtml = DOMPurify.sanitize(rawHtml, {
		USE_PROFILES: { html: true },
		ALLOWED_TAGS: ['p', 'b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'br', 'span', 'a'],
		ALLOWED_ATTR: ['href', 'target', 'rel'],
	});

	return parse(cleanHtml);
};

const renderText = (message: string) => (
	<Box sx={{ textAlign: 'justify' }}>{sanitizeHtml(message)}</Box>
);

function CustomMessage(props: any) {
	const { message, isMyMessage } = useMessageContext();

	const editedAt = message.message_text_updated_at
		? DateTime.fromISO(message.message_text_updated_at).setZone('local').toFormat('dd.MM h:mm a')
		: null;

	const messageActions = isMyMessage()
		? ['delete', 'edit', 'quote', 'react', 'reply']
		: ['flag', 'mute', 'quote', 'react', 'reply', 'markUnread'];

	return (
		<MessageWrapper>
			<MessageSimple
				message={message}
				{...props}
				messageActions={messageActions}
				renderText={renderText}
			/>
			{editedAt && !message.deleted_at && (
				<MessageEditedAt isMyMessage={isMyMessage()}>
					{!isMyMessage() ? <b>{message?.user?.name}</b> : ''} Edited at {editedAt}
				</MessageEditedAt>
			)}
		</MessageWrapper>
	);
}

export default CustomMessage;
